import React, { FC, useState } from 'react';
import { ReactComponent as BlacklistRiderIcon } from 'assets/icons/blacklist-rider-icon.svg';
import { toast } from 'react-toastify';
import { BaseModal, Button, Input, Textarea } from '@cokitchen/cokitchen-components';
import { RiderType } from 'models/rider.model';
import { apiService } from 'utils/api';
import { BLACK_LIST_REASON } from './constant';
interface BlacklistRiderModalType {
  show: boolean;
  onClose: (isSuccess?: boolean) => void;
  rider: RiderType;
}

interface BlacklistRiderFooterType {
  onCancel: () => void;
  loading: boolean;
  onConfirm: () => void;
}

const BlacklistRiderFooter: FC<BlacklistRiderFooterType> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const BlacklistRiderModal: FC<BlacklistRiderModalType> = ({ show, onClose, rider }) => {
  const [value, setValue] = useState<string>('');
  const [comment, setComment] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const sendDetails = async () => {
    if (!rider) return toast('Order has no rider');
    try {
      setLoading(true);
      if (rider?.rider_blacklist) {
        await apiService.put(`logistics/rider/unblacklist/${rider.id}`, {
          baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
        });
      } else {
        const data = {
          rider_id: rider.id,
          reason: value === 'other' ? comment : value
        };
        await apiService.post(`logistics/rider/blacklist/${rider.id}`, {
          data,
          baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
        });
      }
      onClose(true);
    } catch (err: any) {
      toast(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title={
        rider?.rider_blacklist
          ? 'Are you sure you want to unblacklist this rider?'
          : 'Blacklist Rider'
      }
      description={
        rider?.rider_blacklist
          ? "This will enable rider login to the rider's app"
          : 'Any reason why you are blacklisting this rider?'
      }
      titleIcon={<BlacklistRiderIcon />}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <BlacklistRiderFooter
          loading={loading}
          onCancel={() => onClose()}
          onConfirm={sendDetails}
        />
      }>
      {!rider?.rider_blacklist ? (
        <>
          <div className='mr-16'>
            <div className='grid gap-x-5 gap-y-5 md:gap-y-3 md:grid-cols-2 grid-rows-2 my-4'>
              {BLACK_LIST_REASON.map((reason, i) => (
                <Input
                  key={i}
                  value={value}
                  label={reason}
                  className='w-full'
                  type='radio'
                  onChange={() => setValue(reason)}
                  name='blacklist-rider-reasons'
                />
              ))}
            </div>
          </div>
          {value === 'Other' && (
            <div className='mt-2'>
              <Textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder='Add a comment...'
                className='w-full'
              />
            </div>
          )}
        </>
      ) : null}
    </BaseModal>
  );
};

export default BlacklistRiderModal;
